import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogVariantOptions } from 'shared/assets/styles';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './apply-to-occurrences.style';

export type ApplyToOccurrencesDialogProps = {
  open: boolean;
  // opt-in for the caller that raises this from inside a PopupMenu — see z-index.ts
  abovePopups?: boolean;
  title: string;
  message: string;
  singleLabel: string;
  allLabel: string;
  cancelLabel?: string;
  onSingle: () => void;
  onAll: () => void;
  onCancel: () => void;
};

// The three-way "just this one / the whole series / never mind" prompt every recurring
// edit needs. ConfirmDialog deliberately does not cover it — it is yes/no only.
export const ApplyToOccurrencesDialog: React.FC<
  ApplyToOccurrencesDialogProps
> = ({
  open,
  title,
  message,
  singleLabel,
  allLabel,
  cancelLabel,
  onSingle,
  onAll,
  onCancel,
  abovePopups,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Dialog
      $abovePopups={abovePopups}
      open={open}
      onClose={onCancel}
      variant={DialogVariantOptions.ExtraSmall}
    >
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {title}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">{message}</Typography>
      </Styled.Body>

      <Styled.Footer>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.White}
          onClick={onCancel}
        >
          {cancelLabel ?? t('general.cancel')}
        </Button>

        <Styled.Interactions>
          <Button
            variant={Variants.Contained}
            size={Sizes.Medium}
            color={Colors.Error}
            onClick={onAll}
          >
            {allLabel}
          </Button>
          <Button
            variant={Variants.Contained}
            size={Sizes.Medium}
            color={Colors.Error}
            onClick={onSingle}
          >
            {singleLabel}
          </Button>
        </Styled.Interactions>
      </Styled.Footer>
    </Styled.Dialog>
  );
};
